import React, { useEffect, useState } from "react";
import { PageHeader, Loader, Badge, Empty } from "@/components/shared";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtPKR, fmtDate, statusColor } from "@/lib/format";

export default function AdminReferrals() {
  const { t } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/referrals").then(({ data }) => setList(data)).catch(() => {}); }, []);
  if (!list) return <Loader />;

  return (
    <div>
      <PageHeader title={t("referrals")} subtitle={`${list.length} total referrals`} />
      {list.length === 0 ? <Empty label="No referrals yet." /> : (
        <div className="ec-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-gray-500 border-b border-white/10">
              {["Referrer", "Referred Member", "Level", t("status"), t("reward_amount"), "Referral Date"].map((h) => <th key={h} className="text-start font-semibold px-4 py-3">{h}</th>)}
            </tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="border-b border-white/5" data-testid={`admin-ref-${r.id}`}>
                  <td className="px-4 py-3 text-white">{r.referrer_name}</td>
                  <td className="px-4 py-3 text-white">{r.referred_name}</td>
                  <td className="px-4 py-3"><Badge className={statusColor("active")}>L{r.level ?? 1}</Badge></td>
                  <td className="px-4 py-3"><Badge className={statusColor(r.status)}>{r.status}</Badge></td>
                  <td className="px-4 py-3 text-emerald-400 font-semibold">{fmtPKR(r.reward)}</td>
                  <td className="px-4 py-3 text-gray-500">{fmtDate(r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
